var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandLessIcon = function SvgExpandLessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M10.062 5.449c.423 0 .786.182 1.028.484l5.868 6.654c.423.424.363 1.15-.06 1.573-.424.424-1.15.363-1.573-.06l-.061-.06-5.142-5.808c-.06-.06-.12-.06-.242 0l-5.142 5.807c-.423.484-1.089.545-1.573.121-.484-.423-.544-1.089-.12-1.573l.06-.06 5.868-6.655c.302-.241.665-.423 1.089-.423"
  })));
};
export { SvgExpandLessIcon as ReactComponent };